<ion-header class="ion-no-border" mode="md">
  <ion-toolbar>
    <div class="toolbar-content">
      <div class="toolbar-inner">
        <ion-menu-button color="primary"></ion-menu-button>
        @if(!isMobile) {
          <ion-img src="logo-blue.svg" class="logo"></ion-img>
        }
        <div class="button-container">
          <ion-button fill="clear" (click)="goToSettings()">
            <ion-icon class="large" color="primary" name="person-circle-outline"></ion-icon>
          </ion-button>
          <ion-button class="chat-fab" fill="solid" color="secondary" (click)="openChat()">
            <ion-icon name="chatbubbles-outline"></ion-icon>
          </ion-button>
        </div>
      </div>
    </div>
  </ion-toolbar>
</ion-header>
